/* ============
 * Actions for the resolve
 * ============
 *
 * The actions that are available on the
 * resolve module.
 */

import ResolveProxy from '../../../proxies/ResolveProxy';
import types from './mutation-types';

export const getResolveActions = ({ commit, state }) => {
  const { resolveActionsList } = state;
  if (!resolveActionsList.length) {
    commit(types.FETCH_RESOLVE_ACTIONS);
    new ResolveProxy().fetchResolveActions()
      .then(({ resolveActions }) => {
        commit(types.FETCH_RESOLVE_ACTIONS_SUCCESS, resolveActions);
      }).catch((error) => {
        commit(types.FETCH_RESOLVE_ACTIONS_FAIL, error);
      });
  }
};

export default {
  getResolveActions
};
